import React, { Component, Fragment } from 'react';
import { withAsyncActions } from 'react-async-client';
import { Field } from 'formik';
import yup from 'yup';
import { Button, Row, Col } from 'antd';

import { validationProfile } from 'components/common/cards/UserForm';
import { patchUser } from 'actions/asyncActions';
import withAutoFocusForm from 'components/hocs/withAutoFocusForm';
import withForm from 'components/hocs/withForm';
import Input from 'components/common/form/Input';
import File from 'components/common/form/File';
import Checkbox from 'components/common/form/Checkbox';
import Select from 'components/common/form/Select';
import MaskedPhoneInput  from 'components/common/form/MaskedPhoneInput';

@withAutoFocusForm
@withAsyncActions({
    formAction: patchUser
        .withSuccessHandler(({ onSuccess }) => {
            onSuccess && onSuccess();
        })
})
@withForm({
    validationSchema: yup.object().shape(validationProfile, [
        ['instagram', 'vk', 'personal_site'],
        ['facebook', 'instagram', 'personal_site'],
        ['facebook', 'vk', 'personal_site'],
    ]),
    handleSubmit: (values, { props: { formAction } }) => {
        formAction.dispatch({ user: values });
    }
})

export default class ProfileUserForm extends Component {
    
    componentDidMount() {
        const { initialValues: { phone_number, facebook, vk, instagram, personal_site }, setFieldValue } = this.props

        if(phone_number) {
            const checked = (facebook || vk || instagram || personal_site) ? true : null
            setFieldValue('without_education', checked)
        }
    }

    render() {
        
        return (
            <Fragment>
                <Row className="card-info-form">
                    <Col className="card-info-label" xs={12}>
                        Фамилия
                    </Col>
                    <Col xs={12}>
                        <Field
                            name='surname'
                            component={Input}
                            placeholder='Фамилия'
                        />
                    </Col>
                </Row>
                <Row className="card-info-form">
                    <Col className="card-info-label" xs={12}>
                        Имя
                    </Col>
                    <Col xs={12}>
                        <Field
                            name='name'
                            component={Input}
                            placeholder='Имя'
                        />
                    </Col>
                </Row>
                <Row className="card-info-form">
                    <Col className="card-info-label" xs={12}>
                        Отчество
                    </Col>
                    <Col xs={12}>
                        <Field
                            name='patronymic'
                            component={Input}
                            placeholder='Отчество'
                        />
                    </Col>
                </Row>
                <Row className="card-info-form">
                    <Col className="card-info-label" xs={12}>
                        E-mail
                    </Col>
                    <Col xs={12}>
                        <Field
                            name='email'
                            component={Input}
                            placeholder='E-mail'
                            disabled
                        />
                    </Col>
                </Row>
                <Row className="card-info-form">
                    <Col className="card-info-label" xs={12}>
                        Телефон
                    </Col>
                    <Col xs={12}>
                        <Field
                            name='phone_number'
                            component={MaskedPhoneInput}
                            placeholder='Телефон'
                        />
                    </Col>
                </Row>
                <Row className="card-info-form">
                    <Col className="card-info-label" xs={12}>
                        Тип уведомления
                    </Col>
                    <Col xs={12}>
                        <Field
                            name='notification_type'
                            component={Select}
                            dictionary='notification_type'
                            placeholder='Тип уведомлений'
                        />
                    </Col>
                </Row>
                <Row className="card-info-form">
                    <Col className="card-info-label" xs={12}>
                        Страница в Facebook
                    </Col>
                    <Col xs={12}>
                        <Field
                            name='facebook'
                            component={Input}
                        />
                    </Col>
                </Row>
                <Row className="card-info-form">
                    <Col className="card-info-label" xs={12}>
                        Страница в Vkontakte
                    </Col>
                    <Col xs={12}>
                        <Field
                            name='vk'
                            component={Input}
                        />
                    </Col>
                </Row>
                <Row className="card-info-form">
                    <Col className="card-info-label" xs={12}>
                        Страница в Instagram
                    </Col>
                    <Col xs={12}>
                        <Field
                            name='instagram'
                            component={Input}
                        />
                    </Col>
                </Row>

                <Row className="card-info-form">
                    <Col className="card-info-label" xs={12}>
                        Личный сайт
                    </Col>
                    <Col xs={12}>
                        <Field
                            name='personal_site'
                            component={Input}
                        />
                    </Col>
                </Row>
                <Row className="card-info-form">
                    <Col className="card-info-label" xs={12}>
                        Образование
                    </Col>
                    <Col xs={12}>
                        <Field
                            name='education_type'
                            component={Select}
                            dictionary='education_type'
                            placeholder='Образование'
                        />
                    </Col>
                </Row>
                <Row className="card-info-form">
                    <Col className="card-info-label" xs={12}>
                    Учебное заведение
                    </Col>
                    <Col xs={12}>
                        <Field
                            name='institution'
                            component={Input}
                            placeholder='Учебное заведение'
                        />
                    </Col>
                </Row>
                <Row className="card-info-form">
                    <Col className="card-info-label" xs={12}>
                        Диплом
                    </Col>
                    <Col xs={24}>
                        <Field
                            name='file'
                            component={File}
                            placeholder='Загрузите документ об образовании'
                        />
                    </Col>
                    <Col xs={24}>
                        <Field
                            name='without_education'
                            component={Checkbox}
                            additionalText=' У меня нет диплома'
                        />
                    </Col>
                </Row>
                <Row className="card-info-form">
                    <Col className="card-info-label" xs={12}>
                        Тип юр. лица
                    </Col>
                    <Col xs={12}>
                        <Field
                            name='entity_type'
                            component={Select}
                            dictionary='entity_type'
                            placeholder='Тип юр. лица'
                        />
                    </Col>
                </Row>
                <Row className="card-info-form">
                    <Col className="card-info-label" xs={12}>
                        Компания
                    </Col>
                    <Col xs={12}>
                        <Field
                            name='company'
                            component={Input}
                            placeholder='Название компании'
                        />
                    </Col>
                </Row>
                <Row className="form-row">
                    <Button type='primary' htmlType='submit'>
                        Сохранить
                    </Button>
                </Row>
            </Fragment>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/pages/profile/ProfileUserForm.js